import request from '@/utils/request'


// 查询商家申请列表
export function listMerchantApply(query) {
  return request({
    url: '/biz/admin/merchant/apply/list',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询商家申请分页
export function pageMerchantApply(query) {
  return request({
    url: '/biz/admin/merchant/apply/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

export function merchantAudit(data) {
  return request({
    url: '/biz/admin/merchant/apply/audit',
    method: 'post',
    data: data
  })
}

export function marginAudit(data) {
  return request({
    url: '/biz/admin/merchant/apply/audit/margin',
    method: 'post',
    data: data
  })
}

// 查询商家申请详细
export function getMerchantApply(data) {
  return request({
    url: '/biz/admin/merchant/apply/detail',
    method: 'get',
    params: data
  })
}

export function getApplyByMerchantId(data) {
  return request({
    url: '/biz/admin/merchant/apply/detail/merchantId',
    method: 'get',
    params: data
  })
}

export function getApplyByCurrentId(data) {
  return request({
    url: '/biz/admin/merchant/apply/detail/current',
    method: 'post',
    data: data
  })
}


// 新增商家申请
export function addMerchantApply(data) {
  return request({
    url: '/biz/admin/merchant/apply/add',
    method: 'post',
    data: data
  })
}

// 修改商家申请
export function updateMerchantApply(data) {
  return request({
    url: '/biz/admin/merchant/apply/adminEdit',
    method: 'post',
    data: data
  })
}

// 删除商家申请
export function delMerchantApply(data) {
  return request({
    url: '/biz/admin/merchant/apply/delete',
    method: 'post',
    data: data
  })
}
